import type { OfferLabelsTranslation } from '../../offer-labels-content';

export const offerLabels: OfferLabelsTranslation = {
  bestPlaceBadge: 'La nostra tria',
  bestPriceBadge: 'Millor preu',
  regulatedNotice: {
    prescriptionOnly: 'Només amb recepta',
    professionalUse: 'Ús professional',
    fromVeterinarian: 'Disponible a través del vostre veterinari',
    fromPharmacist: 'Disponible a la farmàcia',
    noOnlinePurchase: 'No es ven en línia',
    professionalSupply: 'Es ven a través de proveïdors professionals',
    whyNoLink: 'Analitzem aquest producte, però no hi posem cap enllaç.',
  },
};
